import { inrShort, fmtPct } from '../../utils/format';

/** Revenue-share ring with the total in the middle. `items`: [{ k, v, color }] */
export default function DonutChart({ items, size = 180 }) {
  const total = items.reduce((a, b) => a + b.v, 0) || 1;
  const R = 70, r = 44, cx = 90, cy = 90;
  let a0 = -Math.PI / 2;

  const paths = items.map((it) => {
    const fr = it.v / total;
    const a1 = a0 + fr * 2 * Math.PI;
    const lg = fr > 0.5 ? 1 : 0;
    const x0 = cx + R * Math.cos(a0), y0 = cy + R * Math.sin(a0);
    const x1 = cx + R * Math.cos(a1), y1 = cy + R * Math.sin(a1);
    const xi0 = cx + r * Math.cos(a1), yi0 = cy + r * Math.sin(a1);
    const xi1 = cx + r * Math.cos(a0), yi1 = cy + r * Math.sin(a0);
    const d = `M${x0} ${y0} A${R} ${R} 0 ${lg} 1 ${x1} ${y1} L${xi0} ${yi0} A${r} ${r} 0 ${lg} 0 ${xi1} ${yi1} Z`;
    a0 = a1;
    return { d, it, fr };
  });

  return (
    <svg viewBox="0 0 180 180" width={size} height={size}>
      {paths.map(({ d, it, fr }) => (
        <path
          key={it.k}
          d={d}
          fill={it.color}
          stroke="var(--card)"
          strokeWidth={2}
          data-t={`${it.k}||${inrShort(it.v)} • ${fmtPct(100 * fr)}`}
        />
      ))}
      <text x="90" y="86" textAnchor="middle" style={{ fontSize: 11, fill: 'var(--muted)', fontFamily: 'var(--mono)' }}>
        TOTAL
      </text>
      <text x="90" y="105" textAnchor="middle" style={{ fontSize: 17, fontWeight: 700, fill: 'var(--ink)', fontFamily: 'var(--disp)' }}>
        {inrShort(total)}
      </text>
    </svg>
  );
}
